<page-header class="header" [loadingVideos]="loading"></page-header>

<tags class="tags" [loading]="tagsLoading" [finishedLoading]="tagsFinishedLoading" (scrollAlmostEnd)="loadMoreTags()"
    [ngStyle]="{'visibility': tags.length ? 'visible' : 'hidden'}" [tags]="tags">
</tags>

<ng-container *ngIf="dataLoaded">

    <h2 *ngIf="dataLoaded&&!videos.length&&tags.length>0">לא נמצאו סרטונים</h2>
    <ng-container *ngIf="videos.length">
        <videos class="videos" [videos]="videos"></videos>
    </ng-container>
</ng-container>

<div class="loading-div" *ngIf="!dataLoaded">
    <div class="d-flex justify-content-center">
        <div class="spinner-border large-spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <span>אנחנו מחפשים עבורך את הסרטון המתאים...</span>
</div>

<h2 *ngIf="dataLoaded&&!videos.length&&!tags.length">לא נמצאו תוצאות</h2>

<div class="bottom-spinner">
    <div  *ngIf="dataLoaded&&loading" class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<div id="wraplkjhs" *ngIf="block">
    <h1>נתיב הגן עליך!</h1>
    <h3>
        הטקסט שחיפשת נחסם
    </h3>
</div>